<template>
  <div class="exportTip" v-if="progress > 0 && !cancelExport">
    <div class="exportTip__content">
      <div class="exportTip__content__body">
        <div class="exportTip__content__body__text">
          <p v-if="(progress == 0 || progress < 100) && !showContinueAction">
            {{ $t('export.export_tip', { progress: this.progress }) }}
          </p>
          <p v-if="progress == 100 && !showContinueAction">
            {{ $t('export.export_tip_success', { progress: this.progress }) }}
          </p>
          <p v-if="showContinueAction">
            {{ $t('export.export_tip_continue', { progress: this.progress }) }}
          </p>
        </div>
        <div class="exportTip__content__body__close">
          <span class="continue" v-if="showContinueAction" @click="continueAction">{{
            $t('export.export_tip_continue_btn')
          }}</span>
          <span @click="closeExport" v-if="progress == 0 || progress < 100">{{ $t('export.export_tip_cancel') }}</span>
          <span v-if="progress == 100" @click="cancelAction">
            <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M2.74577 1.9209L1.9209 2.74577L6.17513 7L1.9209 11.2542L2.74577 12.0791L7 7.82487L11.2542
              12.0791L12.0791 11.2542L7.82487 7L12.0791 2.74577L11.2542 1.9209L7 6.17513L2.74577 1.9209Z"
                fill="#8F9193"
              />
            </svg>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DBUtil from '../utils/DBUtil'
import emitter from '@utils/eventbus.js'
import exportMemo from '@utils/exportMemo'
import trackEvent from '@utils/trackEvent'
export default {
  name: 'ExportTip',
  computed: {
    progress() {
      if (this.$store.state.exportProgress == 0) {
        return 0
      }
      return ((this.$store.state.exportProgress / this.$store.state.exportTotal) * 100).toFixed(0)
    },
    cancelExport() {
      return this.$store.state.cancelExport
    },
  },
  data() {
    return {
      showContinueAction: false,
      caches: [],
      exportTip: null,
      query: '',
    }
  },
  methods: {
    continueAction() {
      this.showContinueAction = false
      this.continueExport()
    },
    cancelAction() {
      localStorage.removeItem('advancedSearchQuery')
    },
    async startExport() {
      await this.clearCaches()
      this.continueExport()
    },
    async closeExport() {
      this.$store.commit('setCancelExport', true)
      this.clearCaches()
    },
    continueExport() {
      // this.$api.call('POST', '/user/export_data', {}, (response) => {
      //   if (response.data && response.data.code === 0) {
      //     this.$message.success(response.data.message)
      //   }
      // })
      this.$store.commit('setCancelExport', false)
      if (this.type === null) {
        this.with_tag = undefined
        this.with_link = undefined
        this.with_image = undefined
      }
      if (this.type === 'notag') {
        this.with_tag = false
        this.with_link = undefined
        this.with_image = undefined
      }
      if (this.type === 'link') {
        this.with_link = true
        this.with_tag = undefined
        this.with_image = undefined
      }
      if (this.type === 'image') {
        this.with_image = true
        this.with_tag = undefined
        this.with_link = undefined
      }

      const advancedSearchQuery = localStorage.getItem('advancedSearchQuery')
        ? JSON.parse(localStorage.getItem('advancedSearchQuery'))
        : null

      this.query = this.$route.query.query || this.$store.state.query
      if (advancedSearchQuery) {
        const { date, contain, other, tag } = advancedSearchQuery

        exportMemo(
          contain != 'notContain' && contain != 'all' ? tag : null,
          this.query,
          date.length ? date[0] : null,
          date.length ? date[1] : null,
          this.selected_source == 'export' ? null : this.selected_source, // source web /
          other.length ? other.indexOf('image') > -1 : undefined, // with_image  true 表示必须带有图片 false 表示不带图片 undefined 表示不限制
          undefined,
          other.length ? other.indexOf('link') > -1 : undefined, // with_link 同上
          undefined,
          undefined,
          contain == 'notContain' ? tag : undefined,
          this,
        ).then(() => {
          this.clearCaches()
        })
      } else {
        this.startFullExport()
      }
    },

    // 全量导出
    async startFullExport() {
      const selected_tag = this.$store.state.selected_tag || this.$store.state.pinned_selected_tag
      exportMemo(
        selected_tag,
        this.query,
        this.start_date,
        this.end_date,
        this.selected_source == 'export' ? null : this.selected_source, // source web /
        this.with_image, // with_image  true 表示必须带有图片 false 表示不带图片 undefined 表示不限制
        this.with_tag, // with_tag 同上
        this.with_link, // with_link 同上
        undefined,
        this.type === 'last_year_today' ? 'last_year_today' : undefined,
        undefined,
        this,
      ).then(() => {
        this.clearCaches()
      })
    },
    async clearCaches() {
      this.$store.commit('setExportProgress', 0)
      await DBUtil.deleteZipCache()
      localStorage.removeItem('exportProgress')
      localStorage.removeItem('exportProgress')
      localStorage.removeItem('exportTotal')
      localStorage.removeItem('exportCacheSlug')
    },
  },
  async mounted() {
    const { zipCache } = await DBUtil.getZipCache()
    if (zipCache.length) {
      this.showContinueAction = true
      this.caches = zipCache
    }
    emitter.on('memo-export', () => {
      console.log('memo-export')
      trackEvent('数据导出', '条件-开始')
      this.startExport()
    })
    emitter.on('memo-export-full', () => {
      // console.log('memo-export-full', trackEvent)
      trackEvent('数据导出', '全量-开始')
      this.startExport()
    })
  },
}
</script>
<style scoped lang="scss">
.exportTip {
  position: fixed;
  bottom: 50px;
  left: 50%;
  z-index: 100;
  transform: translate(-50%, -50%);
  transition: all 0.3s ease-in-out;
  &__content {
    background-color: rgba($color: #000000, $alpha: 0.8);
    border-radius: 6px;
    padding: 14px 10px;
    &__body {
      display: flex;
      justify-content: space-between;
      align-items: center;

      &__text {
        color: #ffffff;
        font-size: 12px;
      }
      &__close {
        color: #9d9d9d;
        margin-left: 60px;
        font-size: 12px;
        cursor: pointer;
        .continue {
          margin-right: 20px;
          color: #30cf79;
        }
      }
    }
  }
}
</style>
